import {FieldsOptions} from '@sim/form';
import {FilterFieldsOptions} from '@ui/ui.module';

import {iccdDateValidator} from '@sim/form/validators';

import {CardPaper, CardPaperMeta, ICCDMeta} from '@atmi/core/models/cards/card';
import {
  RelationDMeta,
  RelationFMeta,
  RelationMIMeta,
  RelationOAMeta,
  RelationSMeta
} from '@atmi/core/models/cards/relation';
import {OperaMadre, OperaMadreMeta} from "@atmi/models/cards/card-oa";

export interface EDT {
  /** Nome */
  EDTN: string;
  /** Data */
  EDTD: string;
  /** Luogo */
  EDTL: string;
  /** */
  EDTE: string;
  /** */
  EDTR: string;
}

export interface MIS {
  /** Unità */
  MISU: string;
  /** Altezza */
  MISA: string;
  /** Larghezza */
  MISL: string;
  /** Diametro */
  MISD: string;
  /** Validità */
  MIST: string;
  /** Mancanza */
  MISR: string;
}

export interface MIF {
  /** Unità */
  MIFU: string;
  /** Altezza */
  MIFA: string;
  /** Larghezza */
  MIFL: string;
  /** Diametro */
  MIFD: string;
  /** Varie */
  MIFV: string;
}

export interface CardS extends CardPaper {
  /** Editore / Stampatori */
  EDT: EDT[];
  /** Misure */
  MIS: MIS;
  /**
   * Misure foglio
   * Dimensionidell'intero foglio, espresse sempre in millimetri per le stampe e in centimetri per i manifesti.
   */
  MIF: MIF;
  tiratura: string;
  tipoOperaFiglia?: string;
  operaMadre?: OperaMadre;
  /** Id of the card S parent */
  benePadre?: string;
  numeroEsemplare?: string;
}

export interface CardSFilter {
  codiceUnico?: string;
  ['SGT.SGTT']?: string;
  MTC?: string;
  fornitore?: string;
  benePadre?: string | null;
  tipoOperaFiglia?: string | null;
}

export const EDTMeta: FieldsOptions<EDT> = {
  EDTD: {value: '', validators: [iccdDateValidator()]},
  EDTE: {value: ''},
  EDTL: {value: ''},
  EDTN: {value: ''},
  EDTR: {value: ''},
};

export const MISMeta: FieldsOptions<MIS> = {
  MISA: {value: ''},
  MISL: {value: ''},
  MISR: {value: ''},
  MIST: {value: '', validators: [iccdDateValidator()]},
  MISU: {value: ''},
};

export const MIFMeta: FieldsOptions<MIF> = {
  MIFA: {value: ''},
  MIFD: {value: ''},
  MIFL: {value: ''},
  MIFU: {value: ''},
  MIFV: {value: ''},
};

// FIXME: Why CardS interface does not work
export const CardSMeta: FieldsOptions<any> = {
  ...CardPaperMeta,
  AUT: {...ICCDMeta.AUT, value: [{AUTN: 'Igor Mitoraj', AUTA: 'Oederan, 26 marzo 1944 – Parigi, 6 ottobre 2014'}]},
  EDT: {type: 'array', controls: EDTMeta, additionalInfo: {label: 'Editore / Stampatori'}},
  MIF: {type: 'object', controls: MIFMeta, additionalInfo: {label: 'Misure foglio'}},
  MIS: {type: 'object', controls: MISMeta, additionalInfo: {label: 'Misure'}},
  TSK: {...ICCDMeta.TSK, value: 'S'},
  benePadre: {value: null},
  operaMadre: {value: {}, controls: OperaMadreMeta, type: 'object'},
  relazioniBeniD: {type: 'array', controls: RelationDMeta, value: []},
  relazioniBeniF: {type: 'array', controls: RelationFMeta, value: []},
  relazioniBeniMI: {type: 'array', controls: RelationMIMeta, value: []},
  relazioniBeniOA: {type: 'array', controls: RelationOAMeta, value: []},
  relazioniBeniS: {type: 'array', controls: RelationSMeta, value: []},
  tipoOperaFiglia: {value: ''},
  numeroEsemplare: {value: ''},
  tiratura: {},
};

export const CardSFiltersMeta: FilterFieldsOptions<CardSFilter> = {
  MTC: {operator: 'begins_with'},
  codiceUnico: {operator: 'begins_with'},
  ['SGT.SGTT']: {operator: 'begins_with'},
  fornitore: {operator: 'begins_with'},
  benePadre: {operator: 'equal', typeField: 'oid', value: null, isNullable: true},
  tipoOperaFiglia: {operator: 'equal'},
};
